"use client";

import Link from 'next/link';

interface LogoProps {
  variant?: 'default' | 'light' | 'dark';
  size?: 'sm' | 'md' | 'lg';
}

export default function Logo({ variant = 'default', size = 'md' }: LogoProps) {
  const sizeClasses = {
    sm: 'text-base',
    md: 'text-xl',
    lg: 'text-2xl'
  };

  const iconSizes = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-10 h-10'
  };

  const textColor = variant === 'light' ? 'text-white' : variant === 'dark' ? 'text-slate-900' : '';
  const gradientClass = variant === 'default' ? 'bg-gradient-to-r from-emerald-600 via-teal-600 to-cyan-600 bg-clip-text text-transparent' : textColor;

  return (
    <Link href="/homepage" className="flex items-center gap-3 group">
      {/* Calculator Icon Logo */}
      <div className={`${iconSizes[size]} relative flex items-center justify-center`}>
        <div className="absolute inset-0 bg-gradient-to-br from-emerald-500 via-teal-500 to-cyan-500 rounded-lg rotate-3 group-hover:rotate-6 transition-transform duration-300"></div>
        <div className="relative bg-white rounded-lg shadow-lg p-1.5 group-hover:scale-105 transition-transform duration-300">
          <svg viewBox="0 0 24 24" fill="none" className="w-full h-full">
            <rect x="4" y="2" width="16" height="20" rx="2" stroke="url(#calc-gradient)" strokeWidth="2"/>
            <line x1="7" y1="7" x2="17" y2="7" stroke="url(#calc-gradient)" strokeWidth="1.5" strokeLinecap="round"/>
            <circle cx="8" cy="11" r="1" fill="url(#calc-gradient)"/>
            <circle cx="12" cy="11" r="1" fill="url(#calc-gradient)"/>
            <circle cx="16" cy="11" r="1" fill="url(#calc-gradient)"/>
            <circle cx="8" cy="15" r="1" fill="url(#calc-gradient)"/>
            <circle cx="12" cy="15" r="1" fill="url(#calc-gradient)"/>
            <circle cx="16" cy="15" r="1" fill="url(#calc-gradient)"/>
            <circle cx="8" cy="19" r="1" fill="url(#calc-gradient)"/>
            <rect x="11" y="18" width="5" height="2" rx="1" fill="url(#calc-gradient)"/>
            <defs>
              <linearGradient id="calc-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#10b981"/>
                <stop offset="50%" stopColor="#14b8a6"/>
                <stop offset="100%" stopColor="#06b6d4"/>
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>

      {/* Brand Text */}
      <div className="flex flex-col">
        <span className={`${sizeClasses[size]} font-bold tracking-tight ${gradientClass} leading-none`}>
          American Calculators
        </span>
        <span className="text-[10px] text-slate-500 font-medium tracking-wide uppercase">
          Trusted Financial Tools
        </span>
      </div>
    </Link>
  );
}